import { render } from "./Default.vue?vue&type=template&id=c6c5ef5c&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=c6c5ef5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c5ef5c"],['__file',"src/layouts/Default.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6c5ef5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6c5ef5c', __exports__)) {
    api.reload('c6c5ef5c', __exports__)
  }
  
  module.hot.accept("./Default.vue?vue&type=template&id=c6c5ef5c&scoped=true", () => {
    api.rerender('c6c5ef5c', render)
  })

}


export default __exports__